<template>
  <div class="smartRead-container" :style="{ height: smartReadHeight }">
    <!-- 聊天容器 -->
    <p class="loading-box" v-if="messageLoading">
      <i class="el-icon-loading"></i>
    </p>
    <p class="view-more" @click="getMoreMessage">{{ hasMore ? 'View more' : '' }}</p>
    <div class="smartRead-box"
      v-for="(item, index) in messageHistoryList"
      :key="'message-'+index">
      <template v-for="(value, name) in item">
        <el-divider>{{ name }}</el-divider>
        <div class="message-list">
          <template v-for="message in value">
            <p class="answer" v-if="message.role == 'assistant'">
              <span>
                <strong class="answer-loading-box" v-if="message.loading">
                  <em></em>
                  <em></em>
                  <em></em>
                </strong>
                <VueMarkdown :source="message.content"></VueMarkdown>
                <!-- {{ message.content }} -->
              </span>
            </p>
            <p class="question" v-if="message.role == 'user'">
              <span>{{ message.content }}</span>
            </p>
          </template>
        </div>
      </template>
    </div>
    <!-- 推荐问题 -->
    <div class="recommend-question-box" v-if="showRecommend">
      <h2>
        <span class="lside"><img src="../../assets/img/chatbot.png" alt="">SmartRead</span>
        <em class="el-icon-close" @click="showRecommend = false"></em>
      </h2>
      <ul v-if="quesKeywordsList.questions && quesKeywordsList.questions.length > 0">
        <li
          @click="handleSendKeywords(ques)"
          v-for="(ques, quesIndex) in quesKeywordsList.questions" :key="'ques-'+quesIndex">
          <i class="el-icon-caret-right"></i>
          {{ ques }}
        </li>
      </ul>
      <div class="topic-box" v-if="quesKeywordsList.keywords && quesKeywordsList.keywords.length > 0">
        <span class="title-name">
          Suggest topics:
        </span>
        <p class="tags-box">
          <el-tag
            @click="handleSendKeywords(keywords)"
            v-for="(keywords, keywordsIndex) in quesKeywordsList.keywords"
            :key="'keywords-'+keywordsIndex"
            size="mini"
            effect="plain">
            {{ keywords }}
          </el-tag>
        </p>
      </div>
      <p class="loading-box" v-if="keywordsLoading">
        <i class="el-icon-loading"></i>
      </p>
    </div>
    <!-- 发送问题 -->
    <div class="send-message-box">
      <el-input v-model="messageText" placeholder="请输入您的问题" @keyup.13.native="toSendMessage"></el-input>
      <el-tooltip class="item" effect="dark" content="推荐问题" placement="top">
        <img src="../../assets/img/icon_recommend_active.png" alt="" @click="showRecommend = !showRecommend">
      </el-tooltip>
      <el-button type="primary" @click="toSendMessage" :disabled="sendLoading"><i class="el-icon-loading" v-if="sendLoading"></i> Send</el-button>
    </div>
  </div>
</template>

<script>
  import VueMarkdown from 'vue-markdown'
  export default {
    components: { VueMarkdown },
    data() {
      return{
        messageText: '',
        messageLoading: false,
        keywordsLoading: false,
        showRecommend: true,
        sendLoading: false
      }
    },
    props: ['smartReadHeight', 'quesKeywordsList', 'messageHistoryList', 'hasMore', 'isFinishConversation'],
    methods: {
      getMoreMessage() {
        if (!this.hasMore) return; 
        this.$emit('messageHistory', false)
      },
      handleSendKeywords(data) {
        if (this.sendLoading || !this.isFinishConversation) return; 
        if (data != '') {
          if (this.sendLoading) return;
          this.showRecommend = false;
          this.sendLoading = true;
          this.$emit('sendMessage', data);
        }
      },
      toSendMessage() {
        if (this.sendLoading || !this.isFinishConversation) return; 
        if (this.messageText.trim() == '') {
          this.$message({
            message: '请输入您的问题',
            type: 'warning'
          })
          return
        }
        this.showRecommend = false;
        this.sendLoading = true;
        this.$emit('sendMessage', this.messageText);
        this.messageText = '';
      }
    }
  }
</script>

<style scoped lang="less">
  .smartRead-container{
    padding: 12px 16px;
    height: calc(100vh - 150px);
    overflow: auto;
    scroll-behavior: smooth;
    .loading-box{
      text-align: center;
      margin-bottom: 20px;
      font-size: 20px;
      color: #BDC6D1;
    }
    .view-more{
      font-size: 14px;
      color: #387ED2;
      text-align: center;
      cursor: pointer;
    }
    .smartRead-box{
      margin-top: 20px;
      .el-divider--horizontal{
        width: 60%;
        margin: 0 auto;
        margin-top: 20px;
        .el-divider__text{
          font-size: 12px;
          color: rgba(100, 116, 139, 0.60);
          background-color: #F7F7F8;
        }
      }
      .message-list{
        // width: 95%;
        // margin: 0 auto;
        display: flex;
        flex-direction: column;
        p{
          max-width: 90%;
          margin-top: 20px;
          span{
            padding: 8px 16px;
            border-radius: 8px;
            font-size: 14px;
            display: inline-block;
          }
          &.answer{
            span{
              background: #387ED2;
              color: #fff;
              .answer-loading-box{
                display: flex;
                align-items: center;
                em{
                  width: 6px;
                  height: 6px;
                  border-radius: 50%;
                  background: #fff;
                  margin-right: 4px;
                  animation: loading-ball 1s ease infinite;
                  &:nth-child(1){
                    animation-delay: -.2s
                  }
                  &:nth-child(2){
                    animation-delay: -.1s
                  }
                  &:nth-child(3){
                    animation-delay: 0s
                  }
                }
              }
            }
          }
          &.question{
            -webkit-box-pack: end;
            margin-left: auto;
            span{
              background: #fff;
              color: #262C36;
            }
          }
        }
      }
    }
    @keyframes loading-ball {
      0%, 60%, 100% {
        opacity: 1;
        transform: scale(1);
      }
      30% {
        opacity: .1;
        transform: scale(.01);
      }
    }
    .recommend-question-box{
      width: 97%;
      padding: 12px 0;
      border-radius: 8px;
      background: #fff;
      position: absolute;
      bottom: 64px;
      left: 50%;
      transform: translate(-50%, 0);
      h2{
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #262C36;
        padding: 0 16px;
        .lside{
          display: flex;
          align-items: center;
          flex: 1;
        }
        img{
          width: 28px;
          margin-right: 8px;
        }
        em{
          font-size: 24px;
          cursor: pointer;
        }
      }
      ul{
        margin-top: 15px;
        padding: 0 16px;
        li{
          padding: 8px;
          background: #F7F7F8;
          border-radius: 8px;
          margin-bottom: 12px;
          font-size: 14px;
          color: #262C36;
          cursor: pointer;
          i{
            color: #387ED2;
          }
        }
      }
      .topic-box{
        font-size: 14px;
        color: #262C36;
        display: flex;
        padding: 0 16px;
        .tags-box{
          flex: 1;
        }
        .el-tag{
          color: #64748B;
          border: 1px solid #EBEEF5;
          margin-left: 12px;
          margin-bottom: 12px;
          cursor: pointer;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    /deep/.send-message-box{
      width: 95%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translate(-50%, 0);
      height: 40px;
      border: 1px solid #387ED2;
      border-radius: 8px;
      overflow: hidden;
      background-color: #F7F7F8;
      .el-input__inner{
        border: none;
        background-color: #F7F7F8;
      }
      .el-button--primary{
        border: none;
        background: #387ED2;
        height: 32px;
        width: 65px;
        font-size: 14px;
        padding: 0;
        margin-right: 4px;
      }
      img{
        width: 30px;
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/smartRead/smartRead.vue